import { ResponseOfDataService } from './shared/response-of-data.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ColumnsTableModalSelect,
  ConfirmComponent,
  RadicadosPorFecha,
  ObjectDatesRadication,
  Answer,
  Tarea,
  AnswerTable } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';
import { ResponseOfConfig } from './shared/response-of-config.service';
import { Logger } from '@app/core';
import { environment } from '@env/environment';


const log = new Logger('ResponseOfComponent');

@Component({
  selector: 'iw-response-of',
  templateUrl: './response-of.component.html',
  styleUrls: ['./response-of.component.scss'],
  providers: [ResponseOfDataService]
})
export class ResponseOfComponent implements OnInit {
  // Define si se finalizó la tarea
  @Input() finishTask: boolean = false;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // Control de formulario del select
  form: FormGroup = new FormGroup({
    modalSelect: new FormControl(),
  });
  // Modelo para el checkBox
  checkModel: boolean = null;
  // Lista de opciones para el selector de en respuesta de 
  checkList = [{name: 'Sí', value: true}, {name: 'No', value: false}]
  // Configuraciones de la tabla
  settings = {};
  // Datos para llenar la tabla
  source: LocalDataSource;
  // Modelo para la fecha de inicio
  fromDate: Date;
  // Modelo para la fecha final
  toDate: Date;
  // Pregunta de la modal de confirmaciones
  question = '';
  // fecha maxima a mostrar en el control de fechas
  currentDate: Date;
  // objeto que controla fechas de busqueda de radicados
  dates = new ObjectDatesRadication();
  // Referencia al radicado seleccionado para eliminar
  selectedRadicade: any = {};
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Lista de radicados disponibles
  municipalities: RadicadosPorFecha[];
  // contiene una respuesta a agregar
  answer = new Answer();
  // define si se eliminan todas las respuestas al cambiar el selector a false
  deleteAll = false;
  // Lista de radicados agregados a la tabla
  list: AnswerTable[] = [];

  // variable que controla el input de radicado
  radicateAnswer = environment.radicadoRespuestaDe;
   // contiene la tarea actual
  @Input() task: Tarea;
  // valida el formulario
  @Output() validResponse: EventEmitter<boolean> = new EventEmitter();

  columnsSelect: Array<ColumnsTableModalSelect> = [
    {
      key: 'sede_nombre',
      label: 'Sede',
    },
    {
      key: 'radicado',
      label: 'Radicado',
    },
    {
      key: 'fecha_radicado',
      label: 'Fecha entrada',
    },
  ];
  constructor(
    private toastr: ToastrService,
    private rods: ResponseOfDataService
    ) {
    const docsC = new ResponseOfConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.value);
    });
  }
   ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.currentDate = new Date();
     this.loadAllAnswer();
  }

  defineActionCondictions(action: 'dowmload' | 'eliminar' = 'dowmload', data?: any) {
    switch (action) {
      case 'eliminar':
        this.question = '¿Realmente desea eliminar el radicado de la lista?';
        this.confirm.open();
        this.selectedRadicade = data.id;
        break;

        case 'dowmload':
        this.downloadDocumentGeneration(data);
        break;
    }
  }

  private downloadDocumentGeneration(data: any): any {
    this.rods.downloadAnswer(data.documento_respuesta).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

  async searchRadicades() {
    if ((this.dates.fecha_inicio != null && this.dates.fecha_inicio != '') || (this.dates.fecha_fin != null && this.dates.fecha_fin != '' ) ||
     (this.dates.radicado != null && this.dates.radicado != '')) {
      if (this.dates.fecha_inicio != null &&
        this.dates.fecha_fin != null &&
        this.dates.fecha_inicio > this.dates.fecha_fin) {
        this.toastr.warning('La fecha inicial no puede ser mayor a la fecha final', 'Acción no válida');
      } else {
        this.municipalities = null;
        this.municipalities = await this.rods.getRadicatesByRangeDate(this.dates);
      }
    }
    else {
      if (this.radicateAnswer){
        this.toastr.warning('debe seleccionar al menos una fecha o ingresar número de radicado', 'Acción no válida');
      }else{
        this.toastr.warning('debe seleccionar al menos una fecha', 'Acción no válida');
      }
      
    }
  }

  onSubmit(data: any) {
    let exist = false;
    this.list.forEach((item) => {
      if (item.documento_respuesta === data.controls.modalSelect.value) {
        exist = true;
      }
    });
    if (!exist) {
      this.municipalities.forEach(async (item) => {
        if (item.id === data.controls.modalSelect.value) {
          this.answer.documento_respuesta = item.documento;
          this.answer.tarea =  this.task.id;
          const exec = await this.rods.addAnswer(this.answer);
          if (exec) {
            this.searchRadicades();
            await this.loadAllAnswer();
          }
        }
      });
    } else {
      this.toastr.warning('Ya se añadió este radicado anteriormente', 'Acción no válida');
    }
    data.controls.modalSelect.setValue(null);
  }

  loadAllAnswer() {
    this.list = null;
    this.rods.getAllAnswer(this.task.id).subscribe(answers => {
      this.list = answers;
      if (this.task.fecha_finalizacion){
        this.list.forEach(answ => {
          if (answ) {
            answ['finish'] = true;
          }
        });
      }
      else{
        this.list.forEach(answ => {
          if (answ) {
            answ['finish'] = false;
          }
        });
      }
      this.source = new LocalDataSource(this.list);
      if (answers.length > 0) {
        this.checkModel = true;
        this.validResponse.emit(true);
      } else if(this.checkModel && answers.length === 0) {
        this.validResponse.emit(false);
      }else if(this.finishTask && answers.length === 0) {
        this.checkModel = false;
      }
      this.source.refresh();
    });
  }

  actionConfirm(res: boolean) {
    if (res && this.selectedRadicade && !this.deleteAll) {
      this.rods.deleteAnswer(this.selectedRadicade).then( async es => {
        if (res) {
          await this.loadAllAnswer();
        }
      });
    } else if(this.deleteAll && res) {
      this.list.forEach(ans => {
        this.rods.deleteAnswer(ans.id).then();
      });

      this.list = null;
      this.municipalities = null;
      this.source = new LocalDataSource();
      this.source.refresh();
      this.deleteAll = false;
    }
    if (!this.checkModel && this.deleteAll && !res) {
      this.checkModel = true;
    }
    this.selectedRadicade = null;
  }

  changeCheck(data: any) {
   if (data === false) {
     if (this.list.length > 0) {
    this.question = '¿Realmente desea eliminar el(los) radicado(s) de la lista?';
    this.confirm.open();
    this.deleteAll = true;
     }
    this.validResponse.emit(true);
   } else if (data && this.list.length === 0 || data === null) {
    this.validResponse.emit(false);
   } else if (data && this.list.length > 0) {
    this.validResponse.emit(true);
   }
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/response-of/response-of.component.ts